import type { MagicLinkRequest, Session } from '@repo/contracts';

import { apiFetch } from '../api/client';
import { clearSessionToken, setSessionToken } from './session-token';

export const sessionKeys = {
  all: ['auth', 'session'] as const,
};

/** GET returns `{ authenticated: false, user: null }` rather than throwing when no session token is stored. */
export const fetchSession = () => apiFetch<Session>('/auth/session');

export const createServerSession = async (
  idToken: string,
): Promise<Session> => {
  const session = await apiFetch<Session>('/auth/session', {
    body: JSON.stringify({ idToken }),
    method: 'POST',
  });

  // Present on every create-session response — stored so apiFetch can send
  // it as `Authorization: Bearer <token>` on later requests.
  if (session.sessionToken) {
    setSessionToken(session.sessionToken);
  }

  return session;
};

export const clearServerSession = async (): Promise<{ success: true }> => {
  const result = await apiFetch<{ success: true }>('/auth/session', {
    method: 'DELETE',
  });
  clearSessionToken();

  return result;
};

export const requestMagicLink = (email: string, redirect?: string) =>
  apiFetch<MagicLinkRequest>('/auth/magic-link', {
    body: JSON.stringify({ email, redirect }),
    method: 'POST',
  });
